<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>会员</el-breadcrumb-item>
        <el-breadcrumb-item>会员卡管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" size="small" class="el-icon-circle-plus-outline" v-on:click="AddMemberCard" >新增</el-button>
        </el-form-item>         
        <el-form-item >
          <el-input  placeholder="名称" v-model="queryParam.name" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="memberCards" style="width: 100%">
        <el-table-column  prop="Name" fixed="left" label="名称"> </el-table-column>
        <el-table-column  prop="SoldMoney"  label="售卡金额">
          <template slot-scope="scope">
            <p> {{ scope.row.SoldMoney }}元</p>
          </template>
        </el-table-column>
        <el-table-column  prop="ValidityDays"  label="有效期">
          <template slot-scope="scope">
            <p> {{ scope.row.ValidityDays }}天</p>
          </template>
        </el-table-column>
        <el-table-column  prop="Point"  label="赠送积分">
          <template slot-scope="scope">
            <p> {{ scope.row.Point }}分</p>
          </template>
        </el-table-column>
        <el-table-column  prop="Reward"  label="赠送奖金">
          <template slot-scope="scope">
            <p> {{ scope.row.Reward }}元</p>
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click.native.prevent="EditMemberCard(scope.row.Id)" type="text" size="small">编辑</el-button>
            <el-button @click.native.prevent="deleteRow(scope.row.Id)" type="text" size="small"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParam.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryParam.totalCount">
      </el-pagination>
    </div>   
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        memberCards:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' SoldMoney asc ',
        }
      }
    },
    computed:{
    },
    mounted(){
      if (this.$route.params.queryParam) {
        this.queryParam = this.$route.params.queryParam
      }
      this.MemberCardQuery();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.MemberCardQuery();
      },
      AddMemberCard:function(){
        this.$router.push({
          name:'memberCardInfo',
          params:{
            Id:''
          }
        })
      },
      MemberCardQuery:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/MemberCard/index',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.memberCards = resp.data.memberCards
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      EditMemberCard(id){
        this.$router.push({
          name:'memberCardInfo',
          params:{
            Id:id,
            queryParam: this.queryParam
          }
        })
      },
      deleteRow(id) {
        this.$confirm('确定要删除该会员卡吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/memberCard/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetDate();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>